import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { red, orange } from "@mui/material/colors";
import Header from "./header";
import Footer from "./footer";

const ORANGE_ACCENT = orange?.A400 || orange[600] || "#ff9100";

// Reusable header-like background (matches your hero/header)
const headerLikeBg = {
  position: "relative",
  overflow: "hidden",
  backgroundImage: `linear-gradient(135deg, ${alpha(red[600], 0.08)} 0%, ${alpha(
    ORANGE_ACCENT,
    0.08
  )} 100%)`,
  border: (t) => `1px solid ${t.palette.divider}`,
  "&:before": {
    content: '""',
    position: "absolute",
    inset: 0,
    backgroundImage:
      "radial-gradient(rgba(255,255,255,.16) 1px, transparent 1.5px)",
    backgroundSize: "14px 14px",
    pointerEvents: "none",
  },
};

export default function PrincipalMessagePage() {
  return (
    <>
      <Header />

      {/* HERO */}
      <Box
        sx={{
          pt: { xs: 7, sm: 9 },
          pb: { xs: 5, sm: 7 },
          backgroundImage: `linear-gradient(135deg, ${alpha(
            red[600],
            0.10
          )} 0%, ${alpha(ORANGE_ACCENT, 0.10)} 100%)`,
          borderBottom: `1px solid ${alpha(red[600], 0.18)}`,
          position: "relative",
          overflow: "hidden",
          "&:after": {
            content: '""',
            position: "absolute",
            inset: 0,
            background:
              `radial-gradient(420px 260px at 0% 0%, ${alpha("#fff", .18)} 0%, transparent 60%),
               radial-gradient(460px 280px at 100% 100%, ${alpha("#fff", .10)} 0%, transparent 65%)`,
            pointerEvents: "none",
          },
        }}
      >
        <Container maxWidth="lg">
          <Typography
            component="h1"
            align="center"
            sx={{
              fontWeight: 900,
              // Bigger, fluid title
              fontSize: "clamp(32px, 5vw, 56px)",
              lineHeight: 1.12,
              letterSpacing: 0.2,
              background: `linear-gradient(90deg, ${red[700]} 0%, ${ORANGE_ACCENT} 100%)`,
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
            }}
          >
            Principal’s Message
          </Typography>
        </Container>
      </Box>

      {/* MAIN */}
      <Container maxWidth="lg" sx={{ my: { xs: 3.5, sm: 5 } }}>
        <Grid container spacing={{ xs: 2.5, sm: 3 }}>
          {/* Portrait */}
          <Grid item xs={12} md={4}>
            <Card elevation={0} sx={{ borderRadius: 3, ...headerLikeBg }}>
              <Box
                component="img"
                src="/assets/images/team/principal.jpeg"
                alt="Smt. Mamta Sharma"
                loading="lazy"
                sx={{
                  width: "100%",
                  height: { xs: 360, sm: 420 },
                  objectFit: "cover",
                  borderRadius: 3,
                }}
              />
              <CardContent sx={{ pb: 2 }}>
                <Typography
                  sx={{
                    fontWeight: 900,
                    // Larger name
                    fontSize: "clamp(18px, 2.2vw, 24px)",
                    mb: 0.25,
                  }}
                >
                  Smt. Mamta Sharma
                </Typography>
                <Typography
                  sx={{
                    color: "text.secondary",
                    // Larger caption
                    fontSize: "clamp(13.5px, 1.6vw, 16px)",
                  }}
                >
                  Principal, AISECT Inter College
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          {/* Message */}
          <Grid item xs={12} md={8}>
            <Card
              elevation={0}
              sx={{
                p: { xs: 2.25, sm: 2.75 },
                borderRadius: 3,
                ...headerLikeBg,
              }}
            >
              <Typography
                sx={{
                  fontWeight: 800,
                  // Larger section heading
                  fontSize: "clamp(20px, 2.6vw, 28px)",
                  mb: 1,
                }}
              >
                From the Principal’s Desk
              </Typography>

              <Typography
                sx={{
                  color: "text.secondary",
                  // Larger body text
                  fontSize: "clamp(16.5px, 1.9vw, 19px)",
                  lineHeight: 1.9,
                  mb: 2,
                }}
              >
                It is with great pride and enthusiasm that I welcome you to our
                college in its 3rd year of establishment. Though still young, the
                institution has already begun to make a mark through a commitment to
                academic excellence, holistic development, and community engagement.
              </Typography>

              <Typography
                sx={{
                  color: "text.secondary",
                  fontSize: "clamp(16.5px, 1.9vw, 19px)",
                  lineHeight: 1.9,
                  mb: 2,
                }}
              >
                Our vision is to nurture curious, confident, and compassionate
                individuals. We encourage every student to explore their interests,
                build 21<sup>st</sup>-century skills, and contribute positively to
                society.
              </Typography>

              <Typography
                sx={{
                  color: "text.secondary",
                  fontSize: "clamp(16.5px, 1.9vw, 19px)",
                  lineHeight: 1.9,
                }}
              >
                I invite parents and the community to partner with us. With your
                support, we will continue to create a safe, inclusive, and inspiring
                environment for all learners.
              </Typography>
            </Card>
          </Grid>
        </Grid>
      </Container>

      <Footer />
    </>
  );
}


// import React, { useState } from "react";
// import { Box, Typography, Container } from "@mui/material";
// import { MdCheckCircleOutline } from "react-icons/md";
// import { HiDocumentDownload } from "react-icons/hi";
// import Header from "./header";
// import { Link } from "@mui/material";
// import Footer from "./footer";

// export default function PrincipalMessagePage() {
//   const links = ["2021-2022", "2022-2023", "2023-2024"];
//   const [active, setActive] = useState("2023-2024");

//   var link23 = [
//     { name: "C05 : Notification of the Day", link: "assets/dummy.pdf" },
//     { name: "C03 : Notification of the Day", link: "assets/dummy.pdf" },
//     { name: "C04 : Notification of the Day", link: "assets/dummy.pdf" },
//   ];

//   return (
//     <>
//       <div>
//         <Header />
//         <div>
//           <div className="rbt-banner-area rbt-banner-2 header-transperent-spacer">
//             <div className="wrapper">
//               <Container>
               
//                 <Typography variant="h2" align="center" gutterBottom>
//                   Principal’s Message
//                 </Typography>
//               </Container>
//             </div>
//           </div>
//         </div>
//         {/* End Banner Area */}
//         <br />
//         <Container>
//           <Box display="flex" justifyContent="center">
//             <ul
//               className="nav nav-tabs tab-button-style-2"
//               id="myTab-10"
//               role="tablist"
//             >
//               {links.map((link, index) => (
//                 <li role="presentation" key={index}>
//                   <a
//                     href="#"
//                     className={`tab-button${active === link ? " active" : ""}`}
//                     id="home-tab-4"
//                     data-bs-toggle="tab"
//                     data-bs-target="#home-4"
//                     role="tab"
//                     aria-controls="home"
//                     aria-selected="false"
//                     onClick={() => setActive(link)}
//                   >
//                     <span className="title">{link}</span>
//                   </a>
//                 </li>
//               ))}
//             </ul>
//           </Box>
//           <Box display="flex" justifyContent="center" flexWrap="wrap" mt={4}>
//             {/* {link23.map((e, id) => (
//               <div
//                 key={id}
//                 className={`tab-pane fade${active ? " active show" : ""}`}
//                 id={id}
//                 role="tabpanel"
//                 aria-labelledby="home-tab-4"
//               >
//                 <CircularCard name={e.name} link={e.link} />
//               </div>
//             ))} */}
//             {link23.map((items, index) => (
//               <div className="col-lg-4 col-md-4 col-sm-4 col-12">
//                 <div
//                   key={index}
//                   className="rbt-card card-list-2 event-list-card variation-01 rbt-hover"
//                 >
//                   <div className="rbt-card-body">
//                     <ul className="rbt-meta">
//                       <li key={index}>
//                         <i className="feather-calendar" />
//                         {items.startDate}
//                       </li>
//                       {/* <li>
//                         <i className="feather-map-pin" />
//                         {items.location}
//                       </li> */}
//                     </ul>

//                     <h4 className="rbt-card-title">
//                       <Link to="/event-details">{items.name}</Link>
//                       {/* <a href="event-details.html">{items.eventName}</a> */}
//                     </h4>
//                     <div className="read-more-btn">
//                       <a
//                         className="rbt-btn btn-border hover-icon-reverse btn-sm radius-round"
//                         href={items.link}
//                         target="_blank"
//                       >
//                         <span className="icon-reverse-wrapper">
//                           <span className="btn-text">Download</span>
//                           <span className="btn-icon">
//                             <i className="feather-arrow-right" />
//                           </span>
//                           <span className="btn-icon">
//                             <i className="feather-arrow-right" />
//                           </span>
//                         </span>
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </Box>
//         </Container>
//         <Box sx={{ pb: "30px" }}></Box>

//         <Footer />
//       </div>
//     </>
//   );
// }
